/**
 * Root chrome of every full-tab statement canvas (SELECT, INSERT, UPDATE,
 * DELETE, MERGE and the read-only / parse-error fallbacks), so switching
 * between statements in the statement picker never shifts the cards. The
 * density matches the SELECT cards' `px-3 py-2` padding (round 4).
 */
export const FULL_CANVAS_ROOT_CLASS = 'flex h-full w-full flex-col gap-2 overflow-auto px-5 py-3';
